export enum SpecialOpeningClosingHoursType{
    CLOSING = "CLOSING", 
    OPENING = "OPENING"
}


export class SpecialOpeningClosingHoursRequestFindAll{
    pageSize: number;
    pageNumber: number;
    
}

export class SpecialOpeningClosingHoursRequest{
    date: string = "";
    eFrom: string = "";
    eTo: string = "";
    efrom: string;
    eto: string;
    mFrom: string = "";
    mTo: string = "";
    mfrom: string;
    mto: string;
    note: string = "";
    storeId: number;
    type: SpecialOpeningClosingHoursType;
    
}

export class SpecialOpeningClosingHoursRequestCreate extends SpecialOpeningClosingHoursRequest{
    constructor(){super();}
}

export class SpecialOpeningClosingHoursRequestUpdate extends SpecialOpeningClosingHoursRequest{
    constructor(){super();}
}

export class  SpecialOpeningClosingHoursRequestSearch{
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    storeId: number;
    type: SpecialOpeningClosingHoursType;
    
}